import styled from "@emotion/styled"
import { motion, useInView } from "framer-motion"

import { useConsole } from "contexts/Console"
import { useRef } from "react"

export const paths = {
  o_letter_1:
    "M21.45.74C9.74.74,1,8.95,1,19.95s8.74,19.21,20.45,19.21,20.49-8.25,20.49-19.21S33.16.74,21.45.74ZM21.45,32.98c-8.08,0-13.48-5.28-13.48-13.03s5.4-13.03,13.48-13.03,13.52,5.24,13.52,13.03-5.44,13.03-13.52,13.03Z",
  y_letter_1: "M60.74,38.51h6.8v-15.71L85.14,1.4h-8.58l-12.41,15.17L51.71,1.4h-8.58l17.6,21.44v15.67Z",
  s_letter_1:
    "M106.21,39.16c9.69,0,18.3-2.97,18.3-12,0-7.34-4.41-9.77-13.85-10.6l-6.39-.58c-6.02-.49-8.41-1.03-8.41-4.08,0-3.63,4.45-5.03,10.68-5.03,5.61,0,10.97.99,15.42,2.43l1.07-6.39c-4.78-1.28-10.55-2.23-16.04-2.23-9.61,0-18.14,2.84-18.14,11.5,0,6.84,4.41,9.07,13.85,9.89l6.39.54c6.06.54,8.41,1.24,8.41,4.74,0,4.08-4.53,5.61-10.88,5.61-5.9,0-11.5-.99-16.24-2.43l-1.07,6.39c4.99,1.28,11.13,2.23,16.9,2.23",
  t_letter_1: "M143.81,38.51h6.8V7.54h14.14l.74-6.14h-36.61l.74,6.14h14.18v30.96Z",
  e_letter_1: "M172.46,38.51l34.34-.04-.74-6.14h-26.8v-9.89h22.63v-6.18h-22.63V7.58l26.01-.04.74-6.14h-33.56v37.1Z",
  r_letter_1:
    "M221.73,16.24V7.58h16.08c3.75,0,5.44,1.32,5.44,4.33,0,3.38-2.1,4.33-5.44,4.33h-16.08ZM214.93,38.51h6.8v-16.08h11.87l9.65,16.08h7.75l-9.81-16.33c5.11-.87,8.86-3.92,8.86-10.27s-4.53-10.51-11.96-10.51h-23.17v37.1Z",
  s_letter_2:
    "M43.13,97.3c9.69,0,18.3-2.97,18.3-12,0-7.34-4.41-9.77-13.85-10.6l-6.39-.58c-6.02-.49-8.41-1.03-8.41-4.08,0-3.63,4.45-5.03,10.68-5.03,5.61,0,10.97.99,15.42,2.43l1.07-6.39c-4.78-1.28-10.55-2.23-16.04-2.23-9.61,0-18.14,2.84-18.14,11.5,0,6.84,4.41,9.07,13.85,9.89l6.39.54c6.06.54,8.41,1.24,8.41,4.74,0,4.08-4.53,5.61-10.88,5.61-5.9,0-11.5-.99-16.24-2.43l-1.07,6.39c4.99,1.28,11.13,2.23,16.9,2.23",
  t_letter_2: "M80.73,96.64h6.8v-30.96h14.14l.74-6.14h-36.61l.74,6.14h14.18v30.96Z",
  o_letter_2:
    "M126.58,58.88c-11.71,0-20.45,8.2-20.45,19.21s8.74,19.21,20.45,19.21,20.49-8.25,20.49-19.21-8.78-19.21-20.49-19.21ZM126.58,91.12c-8.08,0-13.48-5.28-13.48-13.03s5.4-13.03,13.48-13.03,13.52,5.24,13.52,13.03-5.44,13.03-13.52,13.03Z",
  r_letter_2:
    "M180.58,80.31c5.11-.87,8.86-3.92,8.86-10.27s-4.53-10.51-11.96-10.51h-23.17v37.1h6.8v-16.08h11.87l9.65,16.08h7.75l-9.81-16.33ZM161.13,74.38v-8.66h16.08c3.75,0,5.44,1.32,5.44,4.33,0,3.38-2.1,4.33-5.44,4.33h-16.08Z",
  y_letter_2: "M211.22,96.64h6.8v-15.71l17.6-21.4h-8.58l-12.41,15.17-12.45-15.17h-8.58l17.6,21.44v15.67Z",
}

export const VB_WIDTH = 252
export const VB_HEIGHT = 98

const Svg = styled(motion.svg)`
  fill: currentColor;
  stroke: currentColor;
  pointer-events: none;
`

function Anim() {
  const console = useConsole()

  const ref = useRef()

  const isInView = useInView(ref, { once: true })

  const variantsGr = {
    on: { transition: { staggerChildren: 0.3 } },
    off: {},
  }

  const variants = {
    on: { pathLength: 1.1, fillOpacity: 1, transition: { duration: 1.1, ease: "easeIn", fillOpacity: { duration: 2.2 } } },
    off: { pathLength: 0, fillOpacity: 0 },
  }
  return (
    <Svg viewBox={`0 0 ${VB_WIDTH} ${VB_HEIGHT}`} aria-labelledby='oyster-story-title' ref={ref} initial='off' animate={isInView ? "on" : "off"}>
      <title id='oyster-story-title'>Oyster Story</title>
      <motion.g strokeWidth={0.5} vectorEffect='non-scaling-stroke'>
        <motion.g id='oyster' variants={variantsGr}>
          <motion.path d={paths.o_letter_1} variants={variants} />
          <motion.path d={paths.y_letter_1} variants={variants} />
          <motion.path d={paths.s_letter_1} variants={variants} />
          <motion.path d={paths.t_letter_1} variants={variants} />
          <motion.path d={paths.e_letter_1} variants={variants} />
          <motion.path d={paths.r_letter_1} variants={variants} />
        </motion.g>
        <motion.g id='story' variants={variantsGr}>
          <motion.path d={paths.s_letter_2} variants={variants} />
          <motion.path d={paths.t_letter_2} variants={variants} />
          <motion.path d={paths.o_letter_2} variants={variants} />
          <motion.path d={paths.r_letter_2} variants={variants} />
          <motion.path d={paths.y_letter_2} variants={variants} />
        </motion.g>
      </motion.g>
    </Svg>
  )
}

export default function OysterStoryLogo({ animated_logo }) {
  const console = useConsole()

  const prefersReducedMotion = process.browser && document.documentElement.classList.contains("prefers-reduced-motion")

  return animated_logo && !prefersReducedMotion ? (
    <Anim />
  ) : (
    <Svg viewBox={`0 0 ${VB_WIDTH} ${VB_HEIGHT}`} aria-labelledby='oyster-story-title'>
      <title id='oyster-story-title'>Oyster Story</title>
      <g id='oyster'>
        <path d={paths.o_letter_1} />
        <path d={paths.y_letter_1} />
        <path d={paths.s_letter_1} />
        <path d={paths.t_letter_1} />
        <path d={paths.e_letter_1} />
        <path d={paths.r_letter_1} />
      </g>
      <g id='story'>
        <path d={paths.s_letter_2} />
        <path d={paths.t_letter_2} />
        <path d={paths.o_letter_2} />
        <path d={paths.r_letter_2} />
        <path d={paths.y_letter_2} />
      </g>
    </Svg>
  )
}
